export enum TypeOfBusiness {
  OPERATING = "Operating",
  HOLDING = "Holding",
}

export const TypeOfBusinessArray: { label: string; value: TypeOfBusiness }[] = [
  {
    label: "Operating",
    value: TypeOfBusiness.OPERATING,
  },
  {
    label: "Holding",
    value: TypeOfBusiness.HOLDING,
  },
];
